import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PayrollSettingsProvider } from "@/context/PayrollSettingsContext";
import { BaseProvider } from "@/context/BaseContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AuditoriaKM from "@/pages/AuditoriaKM";
import AuditoriaEntregas from "@/pages/AuditoriaEntregas";
import Estoque from "@/pages/Estoque";
import Beneficios from "@/pages/Beneficios";
import Historico from "@/pages/Historico";
import Folha from "@/pages/Folha";
import CustoOperacional from "@/pages/CustoOperacional";
import Colaboradores from "@/pages/Colaboradores";
import Ponto from "@/pages/Ponto";
import Faltas from "@/pages/Faltas";
import ContadorHoras from "@/pages/ContadorHoras";
import Bases from "@/pages/Bases";
import Ranking from "@/pages/Ranking";
import Despesas from "@/pages/Despesas";
import Configuracoes from "@/pages/Configuracoes";
import SectionGuard from "@/components/SectionGuard";

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <AuthProvider>
          <BaseProvider>
          <PayrollSettingsProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/auditoria-km" element={<SectionGuard><AuditoriaKM /></SectionGuard>} />
                <Route path="/auditoria-entregas" element={<SectionGuard><AuditoriaEntregas /></SectionGuard>} />
                <Route path="/ponto" element={<SectionGuard><Ponto /></SectionGuard>} />
                <Route path="/contador-horas" element={<SectionGuard><ContadorHoras /></SectionGuard>} />
                <Route path="/faltas" element={<SectionGuard><Faltas /></SectionGuard>} />
                <Route path="/estoque" element={<SectionGuard><Estoque /></SectionGuard>} />
                <Route path="/bases" element={<SectionGuard><Bases /></SectionGuard>} />
                <Route path="/beneficios" element={<SectionGuard><Beneficios /></SectionGuard>} />
                <Route path="/historico" element={<SectionGuard><Historico /></SectionGuard>} />
                <Route path="/folha" element={<SectionGuard><Folha /></SectionGuard>} />
                <Route path="/custo-operacional" element={<SectionGuard><CustoOperacional /></SectionGuard>} />
                <Route path="/colaboradores" element={<SectionGuard><Colaboradores /></SectionGuard>} />
                <Route path="/ranking" element={<SectionGuard><Ranking /></SectionGuard>} />
                <Route path="/despesas" element={<SectionGuard><Despesas /></SectionGuard>} />
                <Route path="/configuracoes" element={<SectionGuard><Configuracoes /></SectionGuard>} />
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
              </Route>
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </PayrollSettingsProvider>
          </BaseProvider>
        </AuthProvider>
        <Toaster position="top-right" richColors theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
